import React from 'react';
import { Gift, Star } from 'lucide-react';

/**
 * LoyaltyCardSection — displays loyalty_points_earned from the shipment object returned by get_public_tracking RPC.
 * The RPC now includes loyalty_points_earned directly in the shipment JSON via coalesce(s.loyalty_points_earned, 0).
 */
const LoyaltyCardSection = ({ shipment }) => {
  // Use loyalty_points_earned directly from shipment (returned by RPC)
  const loyaltyPoints = shipment?.loyalty_points_earned ?? 0;

  return (
    <div className="bg-gradient-to-br from-green-700 to-green-900 rounded-lg shadow-lg p-6 text-white">
      <div className="flex items-center mb-6">
        <Gift className="w-6 h-6 mr-3" />
        <h2 className="text-xl font-bold">Fidélité client</h2>
      </div>

      <div className="flex items-center justify-between bg-white bg-opacity-20 rounded-xl p-5 backdrop-blur-sm">
        <div className="flex items-center space-x-4">
          <div className="w-14 h-14 bg-yellow-400 rounded-full flex items-center justify-center shadow-lg">
            <Star className="w-7 h-7 text-yellow-900" fill="currentColor" />
          </div>
          <div>
            <p className="text-sm font-medium opacity-80">Points fidélité gagnés sur cet envoi</p>
            <p className="text-4xl font-extrabold tracking-tight">
              {loyaltyPoints}
            </p>
            <p className="text-sm opacity-70 mt-1">
              {loyaltyPoints === 0
                ? 'Continuez à expédier pour gagner des points !'
                : loyaltyPoints === 1
                ? '1 point accumulé sur cet envoi'
                : `${loyaltyPoints} points accumulés sur cet envoi`}
            </p>
          </div>
        </div>
      </div>

      <p className="text-xs opacity-60 mt-4 text-center">
        Vous avez {loyaltyPoints} point{loyaltyPoints !== 1 ? 's' : ''} fidélité ADT Express sur cet envoi
      </p>
    </div>
  );
};

export default LoyaltyCardSection;